import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/review-new-empty.png'


const _withScopeId = n => (_pushScopeId("data-v-be9e3726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard__btn" }
const _hoisted_2 = {
  key: 0,
  class: "review-card-list-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "review-card-list__title" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Your Reviews")
  ])
], -1))
const _hoisted_4 = { class: "review-card-list" }
const _hoisted_5 = {
  key: 1,
  class: "empty__content"
}
const _hoisted_6 = { class: "empty__banner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "You don't have any reviews yet!"),
  /*#__PURE__*/_createElementVNode("p", null, " When you complete projects, you’ll receive ratings from the contractors. ")
], -1))
const _hoisted_9 = { class: "empty__banner__footer" }

import projectReviewModal from "@/modules/trade-passport/components/modals/projectReviewModal.vue";
import projectReviewCommentModal from "@/modules/trade-passport/components/modals/projectReviewCommentModal.vue";
import ProjectReviewCard from "@/modules/trade-passport/components/cards/ProjectReviewCard.vue";
import Loader from "@/core/components/common/Loader.vue";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { JOBS_ROUTE } from "@/modules/jobs/routes";
import { useRouter } from "vue-router";
import { ProjectRatingTypeEnum } from "@/core/enums/ProjectsEnum";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { reviewRatingState } from "@/core/models/project-rating";
import { DASHBOARD_ROUTE } from "@/modules/dashboard/routes";
import { PROJECT_ROUTE } from "@/modules/project/routes";
import { getCombineSameProjectReview } from "@/core/utils/common";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewRatingPage',
  setup(__props) {

const store = useStore();
const router = useRouter();
const isShowReviewModal = ref(false);
const isLoading = ref(false);
const isShowReviewCommentModal = ref(false);
const selectedProjectReviewData = ref();
const toggleReviewModal = () => {
  isShowReviewModal.value = !isShowReviewModal.value;
};
const toggleReviewCommentModal = () => {
  isShowReviewCommentModal.value = !isShowReviewCommentModal.value;
};

const onClickViewDetail = (reviewData: any) => {
  selectedProjectReviewData.value = reviewData;
  toggleReviewModal();
  isShowReviewCommentModal.value = false;
};
const onClickViewCommentDetail = (reviewData: any) => {
  selectedProjectReviewData.value = reviewData;
  toggleReviewCommentModal();
  isShowReviewModal.value = false;
};
const onClickGotoProjectPage = () => {
  router.push({ name: PROJECT_ROUTE });
};

const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);

const setAllProjectReviewList = async () => {
  try {
    isLoading.value = true;
    await store.dispatch(
      `${REVIEW_RATING_STORE}/getAllProjectReviewList`,
      ProjectRatingTypeEnum.PROPERTY_OWNER
    );
  } catch (error) {
    console.log("all review list", error);
  } finally {
    isLoading.value = false;
  }
};
const goToDashboard = () => {
  router.push({ name: DASHBOARD_ROUTE });
};
onMounted(async () => {
  if (!getAllProjectReviewList.value?.length) {
    await setAllProjectReviewList();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        onClick: goToDashboard,
        variant: "plain",
        "prepend-icon": "mdi-chevron-left",
        class: "back_dashboard_btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Back to Dashboard")
        ]),
        _: 1
      })
    ]),
    (combineSameProjectReview.value?.length && !isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combineSameProjectReview.value, (review) => {
              return (_openBlock(), _createBlock(ProjectReviewCard, {
                key: review.project.id,
                reviewData: review,
                onOnViewDetail: ($event: any) => (onClickViewDetail(review)),
                onOnViewComment: ($event: any) => (onClickViewCommentDetail(review))
              }, null, 8, ["reviewData", "onOnViewDetail", "onOnViewComment"]))
            }), 128))
          ])
        ]))
      : (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  width: "100%",
                  onClick: onClickGotoProjectPage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Start a new project")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"]),
    (isShowReviewModal.value)
      ? (_openBlock(), _createBlock(projectReviewModal, {
          key: 2,
          reviewData: selectedProjectReviewData.value,
          onOnClose: toggleReviewModal,
          onOnViewComment: _cache[0] || (_cache[0] = ($event: any) => (onClickViewCommentDetail(selectedProjectReviewData.value)))
        }, null, 8, ["reviewData"]))
      : _createCommentVNode("", true),
    (isShowReviewCommentModal.value)
      ? (_openBlock(), _createBlock(projectReviewCommentModal, {
          key: 3,
          reviewData: selectedProjectReviewData.value,
          onOnClose: toggleReviewCommentModal
        }, null, 8, ["reviewData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})